import * as React from 'react'
import { useMenuContext } from '../../state'
import { size } from '../../styles/Media'
import styled from 'styled-components'
import { spacing } from '../../styles/Rythms'
import { Link, navigate } from 'gatsby'
import Caret from '../Caret'
import { useMediaSize } from '../../hooks'

const ParentMenu = styled.div`
  position: relative;
  padding-bottom: 1rem;
  color: var(--text);
  text-decoration: none;
  font-size: var(--font-lg);
  cursor: pointer;

  @media screen and (max-width: ${size.laptop}) {
    padding-left: ${spacing[2]};
    .category-title {
      padding-right: 10px;
      display: grid;
      grid-template-columns: 20px auto 1fr;
      align-items: center;
    }
    .category-title[data-open='true']:after {
      content: '';
      align-self: center;
      border-top: 2px solid var(--primary40);
    }
  }
  @media screen and (min-width: ${size.laptop}) {
    .caret {
      display: none;
    }
  }
`

const SubMenu = styled.div`
  z-index: 3;
  padding: ${spacing[4]};
  gap: 1rem;
  color: var(--text);
  text-align: left;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  flex-direction: column;
  width: auto;
  font-size: var(--font-sm);

  a {
    font-size: var(--font-sm) !important;
  }
  .category-reviews {
    padding: ${spacing[4]};
    border: 1px solid var(--neutral30);
    border-radius: var(--radius-md);
    height: fit-content;
    box-shadow: 0 2px 0 var(--neutral30);
    background: var(--background20);
    max-width: 17rem;
  }

  @media screen and (min-width: ${size.tablet}) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media screen and (min-width: ${size.laptop}) {
    padding: ${spacing[6]};
    position: absolute;
    top: 2rem;
    background: var(--white);
    border-radius: var(--radius-md);
    border: 1px solid var(--neutral30);
    opacity: 1;
    .sub-categories {
      width: clamp(150px, 17vw, 225px);
    }

    .category-reviews {
      width: clamp(100px, 20vw, 225px);
      background: var(--background10);

      li {
        font-weight: var(--font-sm);
      }
    }
  }

  .sub-all {
    margin-bottom: ${spacing[6]};
  }

  .sub-all:hover {
    text-decoration: underline;
    color: var(--primary60);
  }

  .review-title {
    font-size: var(--font-sm);
    font-weight: 700;
    color: var(--primary60);
    margin-bottom: ${spacing[2]};
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  li {
    text-align: left;
    font-weight: 400;
    color: var(--neutral70);
    padding: ${spacing[2]} 0;
    line-height: 135%;
    font-size: var(--font-base);
  }

  a {
    color: var(--text);
  }

  a:hover {
    color: var(--primary60);
    text-decoration: underline;
  }
`
const StyledCaret = styled(Caret)`
  @media screen and (min-width: ${size.laptop}) {
    display: none;
  }
`

export default function NavItemGroup({
  name,
  noun,
  categoryPath,
  navItems,
  current,
  isOpenOnStart = false,
}) {
  const { closeMenu, isMenuOpen } = useMenuContext()
  const [isOpen, setIsOpen] = React.useState(isOpenOnStart)
  const [isSmallScreen] = useMediaSize()

  const onGroupButtonClick = () => {
    // open if not mouse event
    setIsOpen(!isOpen)
    // navigate if clicked
    if (!isSmallScreen) {
      navigate(`/${categoryPath}/`)
      closeMenu()
    }
  }

  return (
    <li>
      <ParentMenu
        isOpen={isOpen}
        onClick={onGroupButtonClick}
        onMouseEnter={() => !isSmallScreen && setIsOpen(true)}
        onMouseLeave={() => !isSmallScreen && setIsOpen(false)}
      >
        <span className="category-title" data-open={isOpen}>
          <span className="caret">
            <Caret style={{ marginBottom: '0' }} direction={isOpen ? 'down' : 'right'} />
          </span>
          <span
            style={{
              marginLeft: spacing[1],
              fontWeight: current ? 'bold' : 'normal',
              fontSize: 'var(--font-base)',
              paddingRight: '10px',
            }}
          >
            {name}
          </span>
        </span>
        {isOpen && (
          <SubMenu isOpen={isOpen}>
            <div className={`sub-categories data-${categoryPath}-popup-box`}>
              <Link
                to={`/${categoryPath}/`}
                className="sub-all"
                onClick={(event) => {
                  event.stopPropagation()
                  setIsOpen(false)
                  closeMenu()
                }}
              >
                Tout voir sur {noun}
                {name.toLowerCase()}
              </Link>
              <ul style={{ marginTop: spacing[2] }}>
                {navItems.subCategories.map((subCat) => (
                  <li key={subCat.name} style={{ padding: '6px 0' }}>
                    <Link
                      to={`/tag/${subCat.name}/`}
                      onClick={(event) => {
                        event.stopPropagation()
                        closeMenu()
                        setIsOpen(false)
                      }}
                    >
                      {subCat.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="category-reviews">
              <div className="review-title">LES AVIS</div>
              <ul>
                {navItems.reviews.map((review) => (
                  <li key={review.path}>
                    <Link
                      to={review.path}
                      onClick={(event) => {
                        event.stopPropagation()
                        setIsOpen(false)
                        closeMenu()
                      }}
                    >
                      {review.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </SubMenu>
        )}
      </ParentMenu>
    </li>
  )
}
